export default __webpack_public_path__ + "static/team3-195897bf697cea12bf055941902f6449.jpg";